/* アルコット — 完コピで剥がした操作を、必要な分だけ書き直したもの。
   元テーマのJSは持ってこない（持ってくると翻訳した中身を上書きして英語に戻る）。
   ここでやるのは「DOMに振る舞いを足す」ことだけ。中身は書き換えない。 */
(() => {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const 数 = (v) => { const m = String(v || '').match(/-?[\d.]+/); return m ? parseFloat(m[0]) : 0; };

  /* ── 1. カルーセル（splide の置き換え） ─────────────────────
     元テーマのクローンは枚数も並びも本物とずれていて、端まで行くと止まるか絵が飛んだ。
     ループ指定のものは、クローンを捨てて本物を前後に1周ずつ並べ直し、
     1枚だけはみ出した所へ送ってから同じ絵の位置へ黙って戻す。これで端が無くなる。 */
  function カルーセル(root) {
    const list = q('.splide__list', root);
    const track = q('.splide__track', root);
    if (!list || !track) return;
    // 端で止まると「戻れない」ので、切ってあるもの以外は全部ループにする
    const ループ = root.classList.contains('splide--loop')
      || (!/splide--destroy/.test(root.className) && Array.from(list.children).filter((x) => !x.classList.contains('splide__slide--clone')).length >= 3);
    const 本物 = Array.from(list.children).filter((s) => !s.classList.contains('splide__slide--clone'));
    if (本物.length < 2) return;

    if (ループ) {
      Array.from(list.children).forEach((s) => { if (s.classList.contains('splide__slide--clone')) s.remove(); });
      const 写す = (s) => {
        const c = s.cloneNode(true);
        c.classList.add('splide__slide--clone');
        c.setAttribute('aria-hidden', 'true');
        qa('img', c).forEach((im) => { im.loading = 'eager'; });
        return c;
      };
      本物.map(写す).reverse().forEach((c) => list.insertBefore(c, list.firstChild));
      本物.map(写す).forEach((c) => list.appendChild(c));
    }
    const 枚 = 本物.length;
    const 先頭 = ループ ? 枚 : 0;                    // 本物の1枚目が children の何番目か
    const 札 = (n) => list.children[先頭 + n] || null;  // ループ時は -枚 〜 枚*2-1 まで引ける。無ければ null（ar-fix が組み替えた後）
    const 任せる = () => !!root.dataset.arFixed;          // ar-fix が持っている枠は触らない（2026-09-10）

    // ドットの数を本物の枚数に合わせて作り直す（写真を足しても数が合う）
    const 点入れ = q('.splide__pagination', root);
    if (点入れ) {
      const 今 = qa('.splide__pagination__page', 点入れ);
      // 元からドットが無いカルーセル（アイコンの列など）には足さない
      if (今.length > 0 && 今.length !== 枚) {
        const ひな = 今[0] ? (今[0].closest('li') || 今[0]) : null;
        点入れ.textContent = '';
        for (let k = 0; k < 枚; k++) {
          let el;
          if (ひな) { el = ひな.cloneNode(true); q('.splide__pagination__page', el)?.classList.remove('is-active'); }
          else { el = document.createElement('li'); const b = document.createElement('button'); b.type = 'button'; b.className = 'splide__pagination__page'; el.appendChild(b); }
          点入れ.appendChild(el);
        }
      }
    }
    const 点 = () => qa('.splide__pagination__page', root);

    const 間隔 = () => (札(1) && 札(0) ? 札(1).offsetLeft - 札(0).offsetLeft : (札(0) ? 札(0).offsetWidth : 0)) || 1;
    const 見える枚数 = () => Math.max(1, Math.round(track.clientWidth / 間隔()));

    let 基準 = 0;
    const 測る = () => {
      if (任せる() || !札(0)) return;   // 札が無い時に測ると undefined.getBoundingClientRect で落ちる（2026-09-10 実測）
      const t = list.style.transition, f = list.style.transform;
      list.style.transition = 'none'; list.style.transform = 'translateX(0px)';
      const 端 = -(札(0).getBoundingClientRect().left - track.getBoundingClientRect().left);
      // 見えている束の幅を出して、余りを半分ずつ左右に置く。
      // これが無いとスマホで1枚が左に寄り、右の隣が見切れて出る
      const 幅 = 見える枚数() * 間隔() - (間隔() - 札(0).offsetWidth);
      基準 = 端 + Math.max(0, (track.clientWidth - 幅) / 2);
      list.style.transform = f; list.style.transition = t;
    };
    測る();
    const 最大 = () => (ループ ? 枚 - 1 : Math.max(0, 枚 - 見える枚数()));
    const 位置 = (n) => { const a = 札(n), z = 札(0); return (a && z) ? 基準 - (a.offsetLeft - z.offsetLeft) : 基準; };

    let i = 0, 送り中 = false;
    const 描く = (n, なめらか) => {
      list.style.transition = なめらか ? 'transform .45s cubic-bezier(.25,.72,.3,1)' : 'none';
      list.style.transform = `translateX(${位置(n)}px)`;
    };
    const 印 = (n) => {
      const 見 = 見える枚数();
      Array.from(list.children).forEach((s) => s.classList.remove('is-active'));
      for (let k = 0; k < 見; k++) 札(ループ ? (n + k) % 枚 : Math.min(n + k, 枚 - 1))?.classList.add('is-active');
      点().forEach((d, k) => {
        const on = k === n;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', String(on));
        d.tabIndex = on ? 0 : -1;
      });
      const prev = q('.splide__arrow--prev', root), next = q('.splide__arrow--next', root);
      if (prev) prev.disabled = !ループ && n <= 0;
      if (next) next.disabled = !ループ && n >= 最大();
    };
    const 行く = (n, なめらか = true) => {
      if (任せる()) return;
      if (ループ) {
        if (送り中) return;
        const 表 = ((n % 枚) + 枚) % 枚;
        描く(n, なめらか); 印(表);
        if (n < 0 || n >= 枚) {
          送り中 = true;
          setTimeout(() => { i = 表; 描く(表, false); 送り中 = false; }, なめらか ? 470 : 0);
        } else { i = 表; }
        return;
      }
      i = Math.max(0, Math.min(n, 最大()));
      描く(i, なめらか); 印(i);
    };

    q('.splide__arrow--next', root)?.addEventListener('click', (e) => { e.preventDefault(); 行く(i + 1); });
    q('.splide__arrow--prev', root)?.addEventListener('click', (e) => { e.preventDefault(); 行く(i - 1); });
    点().forEach((d, k) => d.addEventListener('click', (e) => { e.preventDefault(); 行く(k); }));

    // 指とマウスでの送り。
    // 横に動かした時だけ拾う。縦は画面のスクロールに渡す（前は縦に動かしても掴んでいて、
    // カルーセルの上で下にスクロールできなかった）
    let x0 = null, y0 = 0, base = 0, 向き = null;
    const 開始 = (x, y) => { if (送り中) return; x0 = x; y0 = y; 向き = null; base = 位置(i); };
    const 途中 = (x, y) => {
      if (x0 === null) return false;
      if (向き === null) {
        const dx = Math.abs(x - x0), dy = Math.abs(y - y0);
        if (dx < 6 && dy < 6) return false;
        向き = dx > dy ? '横' : '縦';
        if (向き === '横') list.style.transition = 'none';
      }
      if (向き !== '横') return false;
      list.style.transform = `translateX(${base + (x - x0)}px)`;
      return true;
    };
    const 終わり = (x) => {
      if (x0 === null) return; const d = x - x0; const 横 = 向き === '横'; x0 = null; 向き = null;
      if (!横) return;
      行く(i + (d < -40 ? 1 : d > 40 ? -1 : 0));
    };
    track.addEventListener('touchstart', (e) => 開始(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
    track.addEventListener('touchmove', (e) => 途中(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
    track.addEventListener('touchend', (e) => 終わり(e.changedTouches[0].clientX));
    track.addEventListener('mousedown', (e) => { e.preventDefault(); 開始(e.clientX, e.clientY); });
    window.addEventListener('mousemove', (e) => 途中(e.clientX, e.clientY));
    window.addEventListener('mouseup', (e) => 終わり(e.clientX));
    root.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') 行く(i + 1); if (e.key === 'ArrowLeft') 行く(i - 1); });
    window.addEventListener('resize', () => { 測る(); 行く(i, false); });
    // 写真がまだ読めていないと札の幅が本当の値でなく、置き場所も「何枚見えるか」もずれる。
    // 実測：スマホで1枚しか入らないのに4枚ぶん見えている扱いになり、左に寄って見切れていた。
    // 読み終わりと大きさの変化で測り直す
    const 測り直す = () => { 測る(); 行く(i, false); };
    addEventListener('load', 測り直す);
    if (window.ResizeObserver) {
      let t = null;
      new ResizeObserver(() => { clearTimeout(t); t = setTimeout(測り直す, 60); }).observe(track);
    }
    qa('img', list).forEach((im) => { if (!im.complete) im.addEventListener('load', 測り直す, { once: true }); });
    行く(0, false);

    // 写真のカルーセルは、放っておくと約1.8秒おきに左へ送る（端は無い）
    if (ループ) {
      let 止 = false, 最後 = 0, t = null;
      const 送る = () => { if (止 || 送り中 || Date.now() - 最後 < 6000) return; 行く(i + 1); };
      const 始める = () => { if (!t) t = setInterval(送る, 1800); };
      const 止める = () => { clearInterval(t); t = null; };
      const 触った = () => { 最後 = Date.now(); };
      ['pointerdown', 'touchstart', 'keydown'].forEach((e) => root.addEventListener(e, 触った, { passive: true }));
      // 指の端末は mouseleave が来ないことがあるので、hover が使える所だけ止める
      if (matchMedia('(hover: hover)').matches) {
        root.addEventListener('mouseenter', () => { 止 = true; });
        root.addEventListener('mouseleave', () => { 止 = false; });
      }
      new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? 始める() : 止める())), { threshold: 0.2 }).observe(root);
      document.addEventListener('visibilitychange', () => (document.hidden ? 止める() : 始める()));
    }
  }
  qa('.splide').forEach(カルーセル);

  /* ── 2. 商品ギャラリー（サムネで大画像を切り替える） ───────── */
  (() => {
    const media = qa('.product__media-item');
    const thumbs = qa('.thumbnail-list__item');
    if (!media.length || !thumbs.length) return;
    const 出す = (id) => {
      let 出した = false;
      media.forEach((m) => {
        const on = m.dataset.mediaId === id;
        m.classList.toggle('is-active', on);
        if (on) { 出した = true; m.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
      });
      thumbs.forEach((t) => {
        const on = t.dataset.target === id;
        t.classList.toggle('is-active', on);
        const btn = q('button', t); if (btn) btn.setAttribute('aria-current', on ? 'true' : 'false');
      });
      return 出した;
    };
    thumbs.forEach((t) => {
      const btn = q('button', t) || t;
      btn.addEventListener('click', (e) => { e.preventDefault(); if (t.dataset.target) 出す(t.dataset.target); });
    });
    // 大画像を左右にスワイプしても切り替わるように
    const list = q('.product__media-list');
    if (list) {
      let x0 = null;
      list.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      list.addEventListener('touchend', (e) => {
        if (x0 === null) return; const d = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(d) < 40) return;
        const now = media.findIndex((m) => m.classList.contains('is-active'));
        const n = Math.max(0, Math.min(media.length - 1, now + (d < 0 ? 1 : -1)));
        出す(media[n].dataset.mediaId);
      });
    }
  })();

  /* ── 3. 引き出し（メニュー・カート・検索） ───────────────── */
  (() => {
    const 開閉 = (箱, 開く) => {
      if (!箱) return;
      箱.classList.toggle('active', 開く);
      箱.classList.toggle('is-open', 開く);
      箱.setAttribute('aria-hidden', String(!開く));
      箱.style.visibility = 開く ? 'visible' : '';
      箱.style.opacity = 開く ? '1' : '';
      箱.style.transform = 開く ? 'translateX(0)' : '';
      document.body.classList.toggle('overflow-hidden', 開く);
    };
    const カート = q('#CartDrawer') || q('cart-drawer');
    qa('#cart-icon-bubble, a[href*="/cart"], .header__icon--cart').forEach((b) => {
      b.addEventListener('click', (e) => { e.preventDefault(); 開閉(カート, true); });
    });
    qa('.drawer__close, [id*="CartDrawer-Overlay"], .cart-drawer__overlay').forEach((b) => {
      b.addEventListener('click', (e) => { e.preventDefault(); 開閉(カート, false); });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') 開閉(カート, false); });
  })();

  /* ── 4. 「サイズを選ぶ」などのボタンを購入エリアに繋ぐ ─────── */
  (() => {
    const 行き先 = q('variant-selects') || q('.product-form__input') || q('product-info');
    if (!行き先) return;
    const 語 = ['サイズを選ぶ', 'この価格で買う', 'サイズ表を見る'];
    qa('button, a').forEach((b) => {
      const t = (b.textContent || '').replace(/\s+/g, ' ').trim();
      if (!語.some((w) => t === w || t.startsWith(w))) return;
      if (b.closest('[data-hone-wired]')) return;
      b.addEventListener('click', (e) => {
        if (b.tagName === 'A' && b.getAttribute('href') && !b.getAttribute('href').startsWith('#')) return;
        e.preventDefault();
        行き先.scrollIntoView({ behavior: 'smooth', block: 'center' });
        行き先.classList.add('hone-blink');
        setTimeout(() => 行き先.classList.remove('hone-blink'), 1200);
      });
    });
  })();

  /* ── 5. カウントダウンは下の「時計」で1本にまとめた ───────── */

  /* ── 6. 前後を見比べるスライダーは下の「見比べ」に1本化した ── */

  /* ── 7. 束を選んだら、上の価格の表示も合わせる ─────────────── */
  (() => {
    const 束 = qa('quantity-breaks input[type="radio"], .quantity-breaks input[type="radio"]');
    if (!束.length) return;
    束.forEach((r) => r.addEventListener('change', () => {
      qa('quantity-breaks label, .quantity-breaks label').forEach((l) => {
        const inp = q('input[type="radio"]', l) || document.getElementById(l.getAttribute('for') || '');
        l.classList.toggle('is-selected', !!(inp && inp.checked));
      });
    }));
  })();

  const st = document.createElement('style');
  st.textContent = '.hone-blink{outline:3px solid #ff5c01;outline-offset:6px;border-radius:8px;transition:outline-color .3s}';
  document.head.appendChild(st);
})();

/* ── 買えるようにする（独立検査 2026-08-30 の指摘 A/B/E/F/N/R への対応） ── */
(() => {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  // ボタンの文字は先頭にアイコンの合字が混ざる（例 "straighten サイズ表を見る"）。それを外して読む
  // 先に trim してから合字を外す（前に空白があると外れない。実測で1度これで外した）
  const 文字 = (el) => (el.textContent || '').replace(/[\uE000-\uF8FF]/g, '').replace(/\s+/g, ' ').trim().replace(/^[a-z_]+\s+/, '').trim()  /* 2026-09-10: アイコンは私用領域の1文字(&#xE41C;)になっているので先に落とす。落とさないと「サイズ表を見る」が一致せず開かなかった */;

  /* R 購入ボタンが「押せない」状態で固定されていた */
  qa('.product-form__buttons.disabled, .sticky-atc__button.disabled').forEach((el) => el.classList.remove('disabled'));
  qa('button[disabled]').forEach((b) => { if (/カートに入れる|サイズを選ぶ|レジへ進む/.test(文字(b))) b.disabled = false; });

  /* A 画面下の購入バーが一度も出てこない（画面のすぐ下に停まっていた） */
  (() => {
    const bar = q('sticky-atc, .sticky-atc');
    const 元 = q('[data-atc], .product-form__submit, .product-form__buttons');
    if (!bar || !元) return;
    const st = document.createElement('style');
    st.textContent = 'sticky-atc,.sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:70;transform:translateY(110%);transition:transform .3s cubic-bezier(.22,1,.36,1)}sticky-atc.hone-on,.sticky-atc.hone-on{transform:translateY(0)!important}';
    document.head.appendChild(st);
    const 更新 = () => bar.classList.toggle('hone-on', 元.getBoundingClientRect().bottom <= 0);
    addEventListener('scroll', 更新, { passive: true }); addEventListener('resize', 更新); 更新();
  })();

  /* B カートを押しても開かない（隠しているのは親の .drawer だった）＋ 先頭に飛ぶ */
  (() => {
    const 親 = q('.drawer'), 子 = q('cart-drawer');
    if (!親) return;
    const 開閉 = (開く) => {
      [親, 子].forEach((el) => { if (!el) return;
        el.classList.toggle('active', 開く); el.classList.toggle('is-open', 開く);
        el.style.visibility = 開く ? 'visible' : ''; el.style.opacity = 開く ? '1' : '';
        el.style.transform = 開く ? 'translateX(0)' : ''; el.style.pointerEvents = 開く ? 'auto' : ''; });
      // html に overflow:hidden を当てるとスクロール位置が先頭に戻るので、位置を覚えて戻す
      const y = window.scrollY;
      document.body.classList.toggle('overflow-hidden', 開く);
      閉じるボタン.style.display = 開く ? 'grid' : 'none';
      requestAnimationFrame(() => { if (window.scrollY !== y) window.scrollTo(0, y); });
    };
    // 見える閉じるボタンを足す（元の閉じるボタンは隠れた中にあって押せなかった）
    const 閉じるボタン = document.createElement('button');
    閉じるボタン.type = 'button'; 閉じるボタン.textContent = '×'; 閉じるボタン.setAttribute('aria-label', 'カートを閉じる');
    閉じるボタン.style.cssText = 'display:none;position:fixed;z-index:120;top:14px;right:14px;width:44px;height:44px;place-items:center;border-radius:50%;background:#111;color:#fff;font-size:24px;line-height:1;cursor:pointer';
    閉じるボタン.addEventListener('click', () => 開閉(false));
    document.body.appendChild(閉じるボタン);
    qa('#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href$="/cart"]').forEach((b) =>
      b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); 開閉(true); }, true));
    addEventListener('keydown', (e) => { if (e.key === 'Escape') 開閉(false); });
  })();

  /* E 「サイズ表を見る」が開かない（合字のせいで文字が一致しなかった） */
  (() => {
    const 箱 = q('.product-popup-modal, product-modal, [id^="PopupModal-"]');
    qa('button, a').filter((b) => 文字(b) === 'サイズ表を見る').forEach((b) => {
      b.addEventListener('click', (e) => {
        e.preventDefault();
        if (箱) { 箱.classList.add('active','is-open'); 箱.style.visibility='visible'; 箱.style.opacity='1'; 箱.setAttribute('open',''); 箱.scrollIntoView({behavior:'smooth',block:'center'}); }
        else { const t = qa('table').find((x)=>/cm/.test(x.textContent)); if (t) t.scrollIntoView({behavior:'smooth',block:'center'}); }
      });
    });
    if (箱) qa('.product-popup-modal__toggle, [id^="ModalClose-"]', 箱).forEach((c)=>c.addEventListener('click',()=>{箱.classList.remove('active','is-open');箱.style.visibility='';箱.style.opacity='';箱.removeAttribute('open');}));
  })();

  /* F 本数を選んでも上の価格が変わらない
     → 札の文字から拾う方式は 5足の札で誤読したので捨てた。
        対応表から引く 価格同期() に移した（下の「買えるようにする」の中） */

  /* N 「この価格で買う」が別商品のページを指していた */
  qa('a').filter((a) => ['この価格で買う', 'サイズを選ぶ'].includes(文字(a))).forEach((a) => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const 行 = q('variant-selects') || q('.product-form__input') || q('product-info');
      if (行) { 行.scrollIntoView({ behavior: 'smooth', block: 'center' }); 行.classList.add('hone-blink'); setTimeout(()=>行.classList.remove('hone-blink'), 1200); }
    });
  });
})();

/* ── 見た目の崩れ（独立検査の I/J/H/T/S） ─────────────────── */
(() => {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* 時計。時・分・秒がそれぞれ自分の桁を動かす。
     前は「日」の枠（画面には出ていない）まで数えて3つずつ組にしていたので、
     時間の枠に分が、分の枠に秒が入り、秒の枠は止まったままだった。
     枠は class で名指しする。終わりの時刻は端末ごとに持って、切れたらまた24時間で立て直す。 */
  (() => {
    const 枠 = qa('.goodt-cart__timer');
    if (!枠.length) return;
    const 窓 = 24 * 3600 * 1000;                       // 1周24時間
    const 鍵 = 'arukoto:sale-deadline';
    let 終 = Number(localStorage.getItem(鍵) || 0);
    if (!終 || 終 - Date.now() <= 0 || 終 - Date.now() > 窓) {
      終 = Date.now() + 窓;
      try { localStorage.setItem(鍵, String(終)); } catch {}
    }
    const p = (n) => String(n).padStart(2, '0');
    const 書く = () => {
      const 残 = Math.max(0, Math.floor((終 - Date.now()) / 1000));
      const 日 = Math.floor(残 / 86400);
      const 値 = { days: p(日), hours: p(Math.floor(残 % 86400 / 3600)), minutes: p(Math.floor(残 % 3600 / 60)), seconds: p(残 % 60) };
      枠.forEach((b) => Object.entries(値).forEach(([k, v]) => {
        const el = q('.goodt-cart__' + k, b);
        if (el && el.textContent !== v) el.textContent = v;
      }));
      if (残 === 0) {                                   // 0になったら次の24時間へ
        終 = Date.now() + 窓;
        try { localStorage.setItem(鍵, String(終)); } catch {}
      }
    };
    書く();
    setInterval(書く, 1000);
  })();

  /* 見比べ（使う前／使った後）。
     壊れていたのは2つ。
     (1) 上に載る「使う前」の層（.comparison-slider__overlay）が**幅の半分しか無かった**。
         元テーマのJSがここの幅をつまみに合わせて動かしていたのを剥がしたため、50%のまま固まり、
         写真は横に潰れ、右側は何も無い白地になっていた（実測 overlay 225px / 枠 450px）。
     (2) 同じ要素に実装が2つあり、片方が range の入力そのものを left で動かしていたので、
         つかんで引くと値が0に飛んだ。
     直し方：層は両方とも枠いっぱいに広げ、上の「使う前」を左からの帯で切る。range は値だけ扱う。 */
  (() => {
    const 枠 = qa('comparison-slider, .comparison-slider');
    if (!枠.length) return;
    const st = document.createElement('style');
    st.textContent = `
comparison-slider,.comparison-slider{ position:relative; }
comparison-slider .comparison-slider__overlay,.comparison-slider .comparison-slider__overlay{
  position:absolute !important; left:0; top:0; width:100% !important; height:100% !important;
  max-width:none !important; overflow:hidden; }
comparison-slider .comparison-slider__overlay img,.comparison-slider .comparison-slider__overlay img,
comparison-slider .comparison-slider__underlay img,.comparison-slider .comparison-slider__underlay img{
  width:100% !important; height:100% !important; max-width:none !important; object-fit:fill !important; display:block; }
comparison-slider .comparison-slider__line,.comparison-slider .comparison-slider__line{ z-index:3; }
comparison-slider .comparison-slider__before-text,.comparison-slider .comparison-slider__before-text,
comparison-slider .comparison-slider__after-text,.comparison-slider .comparison-slider__after-text{ z-index:4; }
comparison-slider input[type="range"],.comparison-slider input[type="range"]{
  position:absolute !important; left:0 !important; top:0 !important; width:100% !important; height:100% !important;
  margin:0 !important; opacity:0; z-index:5; cursor:ew-resize;
  /* 指では触らせない。range が縦の動きも飲み込んで、枠の上でスクロールできなくなる */
  touch-action:pan-y; }
@media (hover: none){ comparison-slider input[type="range"],.comparison-slider input[type="range"]{ pointer-events:none; } }
comparison-slider,.comparison-slider{ touch-action:pan-y; }
`;
    document.head.appendChild(st);

    枠.forEach((root) => {
      const 前層 = q('.comparison-slider__overlay', root);   // 使う前（上に載る）
      const 線 = q('.comparison-slider__line', root);
      const 入力 = q('input[type="range"]', root);
      if (!前層) return;
      let p = 50;
      const 描く = () => {
        前層.style.clipPath = `inset(0 ${100 - p}% 0 0)`;     // 左から p% だけ「使う前」を見せる
        const 下 = q('.comparison-slider__underlay img', root);
        if (下) 下.style.clipPath = '';                        // 前の実装が下の写真を切っていたので戻す
        if (線) 線.style.left = `${p}%`;
        if (入力) 入力.value = String(Math.round(p));
      };
      const 位置 = (x) => {
        const r = root.getBoundingClientRect();
        p = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
        描く();
      };
      // 押した瞬間に動かすのはマウスだけ。指は「横に動かした」と分かってから。
      // 前は触った時点で掴んでいたので、この枠の上で下にスクロールできなかった
      let 押 = false;
      root.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        e.preventDefault(); 押 = true; root.classList.add('is-dragging'); 位置(e.clientX);
      });
      addEventListener('pointermove', (e) => { if (押) 位置(e.clientX); });
      addEventListener('pointerup', () => { 押 = false; root.classList.remove('is-dragging'); });
      let tx = null, ty = 0, 横 = null;
      root.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; ty = e.touches[0].clientY; 横 = null; }, { passive: true });
      root.addEventListener('touchmove', (e) => {
        if (tx === null) return;
        const x = e.touches[0].clientX, y = e.touches[0].clientY;
        if (横 === null) {
          const dx = Math.abs(x - tx), dy = Math.abs(y - ty);
          if (dx < 8 && dy < 8) return;
          横 = dx > dy;
        }
        if (横) 位置(x);
      }, { passive: true });
      root.addEventListener('touchend', () => { tx = null; 横 = null; });
      if (入力) {
        入力.addEventListener('input', () => { p = Number(入力.value); 描く(); });
        入力.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { p = Math.max(0, p - 2); 描く(); }
          if (e.key === 'ArrowRight') { p = Math.min(100, p + 2); 描く(); }
        });
      }
      描く();
    });
  })();

  /* S 動画が data-src のままで再生されない */
  qa('video').forEach((v) => {
    let 直した = false;
    qa('source', v).forEach((so) => { const d = so.getAttribute('data-src'); if (d && !so.getAttribute('src')) { so.setAttribute('src', d); 直した = true; } });
    const d = v.getAttribute('data-src'); if (d && !v.getAttribute('src')) { v.setAttribute('src', d); 直した = true; }
    if (直した) { v.load(); v.muted = true; v.setAttribute('playsinline', ''); v.play().catch(() => {}); }
  });

  /* I スマホでカルーセルの中身が83pxまで潰れる */
  /* J レビューが1列に重なって、間に300pxの空白ができる */
  const st = document.createElement('style');
  st.textContent = `
@media (max-width: 749px){
  #splide02 .splide__slide, #splide04 .splide__slide{ min-width: 76vw !important; width: 76vw !important; }
  .jdgm-rev-widg__reviews{ display: block !important; height: auto !important; }
  .jdgm-rev{ position: static !important; width: 100% !important; left: auto !important; top: auto !important; margin: 0 0 16px !important; }
}
@media (min-width: 750px){
  .jdgm-rev-widg__reviews{ display: grid !important; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 18px; height: auto !important; }
  .jdgm-rev{ position: static !important; width: 100% !important; left: auto !important; top: auto !important; margin: 0 !important; }
}`;
  document.head.appendChild(st);
})();

/* ── レビュー欄の見た目（Trustpilot の形）と並べ方 ────────────────
   直したのは3つ。
   (1) 見出しの「88,552件のレビューより」が左に取り残されていた → 星の下に中央で置く
   (2) カードが2列で、枠も日付も出どころも無かった → 枠つきのカードにして、名前・日付・星・写真・本文・下の行を入れる
   (3) 写真が縦にしか並ばなかった → 横3枚（画面が狭ければ2枚→1枚）
   枠の大きさ（カードの幅・写真の比率）は元のまま。色と中身の置き場所だけ変える。 */
(() => {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const 箱 = q('.jdgm-rev-widg');
  if (!箱) return;

  const 色 = ['#e3f2e8', '#fdeadf', '#e6ecfa', '#fbe9f0', '#e9f1f6', '#f4eddc'];
  const 文字色 = ['#2f6b46', '#9c4a15', '#2f4a8c', '#8c2f57', '#2f5f77', '#7a6420'];

  qa('.jdgm-rev', 箱).forEach((card, n) => {
    if (card.dataset.honeCard) return;
    card.dataset.honeCard = '1';
    const 名 = (q('.jdgm-rev__author', card)?.textContent || '').trim();
    const 印 = q('.jdgm-rev__icon', card);
    if (印 && !印.textContent.trim()) {
      印.textContent = 名 ? [...名][0] : '★';
      印.style.background = 色[n % 色.length];
      印.style.color = 文字色[n % 文字色.length];
    }
    // 日付を名前の下へ。表記も日本語に
    const 時 = q('.jdgm-rev__timestamp', card);
    const 人 = q('.jdgm-row-profile', card);
    if (時 && 人) {
      const d = new Date(時.getAttribute('datetime') || 時.textContent);
      if (!isNaN(d)) 時.textContent = `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
      const 縦 = document.createElement('span');
      縦.className = 'hone-rev__who';
      const 名前 = q('.jdgm-rev__author-wrapper', card);
      if (名前) { 人.appendChild(縦); 縦.appendChild(名前); 縦.appendChild(時); }
    }
    // 下の行（役に立った・共有）。押して何も起きない飾りは置かない
    const 足 = q('.jdgm-rev__votes', card);
    if (足 && !足.children.length) {
      const 役 = document.createElement('button');
      役.type = 'button'; 役.className = 'hone-rev__act';
      let 数 = 0;
      const 塗る = () => { 役.textContent = `役に立った${数 ? ' ' + 数 : ''}`; 役.classList.toggle('is-on', 数 > 0); };
      塗る();
      役.addEventListener('click', () => { 数 = 数 ? 0 : 1; 塗る(); });
      const 共 = document.createElement('button');
      共.type = 'button'; 共.className = 'hone-rev__act'; 共.textContent = '共有';
      共.addEventListener('click', async () => {
        const u = location.href;
        try {
          if (navigator.share) await navigator.share({ url: u, title: document.title });
          else { await navigator.clipboard.writeText(u); 共.textContent = 'コピーしました'; setTimeout(() => (共.textContent = '共有'), 1500); }
        } catch {}
      });
      足.append(役, 共);
    }
  });

  /* ページ送り（1／2／3）。元は judge.me が次のページを取りに行っていた所。
     ここは静止したページなので、全部のカードを持ったまま5件ずつ出し入れする。 */
  (() => {
    const 送り = q('.jdgm-paginate', 箱);
    const 入れ物 = q('.jdgm-rev-widg__reviews', 箱);
    if (!送り || !入れ物) return;
    const 札 = qa('.jdgm-rev', 入れ物);
    const 一頁 = Number(送り.dataset.perPage) || 5;
    const 頁数 = Math.max(1, Math.ceil(札.length / 一頁));
    const 番号 = qa('.jdgm-paginate__page', 送り).filter((a) => !a.classList.contains('jdgm-paginate__next-page'));
    const 次 = q('.jdgm-paginate__next-page', 送り);
    // 札の数に合うだけの番号を出す（足りなければ足し、余れば消す）
    番号.forEach((a, k) => { a.hidden = k >= 頁数; });
    for (let k = 番号.length; k < 頁数; k++) {
      const a = 番号[0].cloneNode(true);
      a.classList.remove('jdgm-curt'); a.removeAttribute('aria-current');
      a.dataset.page = String(k + 1); a.textContent = String(k + 1);
      送り.insertBefore(a, 次 || null); 番号.push(a);
    }
    let 今 = 1;
    const 出す = (n, 動かす) => {
      今 = Math.max(1, Math.min(n, 頁数));
      札.forEach((el, k) => { el.hidden = Math.floor(k / 一頁) + 1 !== 今; });
      番号.forEach((a) => {
        const on = Number(a.dataset.page) === 今;
        a.classList.toggle('jdgm-curt', on);
        if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
      });
      if (次) { 次.dataset.page = String(今 < 頁数 ? 今 + 1 : 1); 次.hidden = 頁数 < 2; }
      if (動かす) 箱.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    番号.forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); 出す(Number(a.dataset.page), true); }));
    次?.addEventListener('click', (e) => { e.preventDefault(); 出す(今 < 頁数 ? 今 + 1 : 1, true); });
    出す(1, false);
  })();

  const st = document.createElement('style');
  st.textContent = `
/* 見出し */
.jdgm-rev-widg__header{ text-align:center; }
.jdgm-rev-widg__summary,
.jdgm-rev-widg__summary-inner{ display:flex; flex-direction:column; align-items:center; gap:8px; width:100%; }
.jdgm-rev-widg__summary-stars{ display:flex; align-items:center; justify-content:center; gap:8px; }
.jdgm-rev-widg__summary-text{ position:static !important; float:none !important; margin:0 !important;
  display:flex; align-items:center; justify-content:center; gap:6px; color:#5b5b6b; font-size:1.4rem; }
.jdgm-row-stars{ display:flex; flex-direction:column; align-items:center; }
.jdgm-histogram{ width:100%; max-width:420px; margin:14px auto 0; }
.jdgm-histogram__bar-content{ background:#00b67a !important; }

/* 星（Trustpilot の四角）
   judge.me の星は専用フォントの合字で、四角の中に入れるとベースラインの分だけ
   右下にずれて真ん中に来なかった（フェイクに見える原因）。合字を消して、
   四角のど真ん中に白い星のSVGを敷く。 */
.jdgm-rev-widg .jdgm-star{ display:inline-block !important; vertical-align:middle;
  width:22px !important; height:22px !important; margin:0 3px 0 0 !important; padding:0 !important;
  border-radius:3px; background-color:#00b67a; color:transparent !important;
  font-size:0 !important; line-height:0 !important; text-indent:-9999px; overflow:hidden;
  background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 20 19'%3E%3Cpath fill='%23ffffff' d='M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:50% 50%; background-size:64% 64%; }
.jdgm-rev-widg .jdgm-star::before,.jdgm-rev-widg .jdgm-star::after{ content:"" !important; display:none !important; }
.jdgm-rev-widg .jdgm-star.jdgm--off{ background-color:#dcdce6; }
.jdgm-rev-widg .jdgm-star.jdgm--half{ background-color:#dcdce6;
  background-image:linear-gradient(90deg,#00b67a 50%,transparent 50%),
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 20 19'%3E%3Cpath fill='%23ffffff' d='M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/%3E%3C/svg%3E");
  background-size:100% 100%,64% 64%; background-position:0 0,50% 50%; }
.jdgm-rev-widg .jdgm-histogram__star .jdgm-star{ width:17px !important; height:17px !important; margin-right:2px !important; }
.jdgm-rev-widg .jdgm-rev__rating{ display:inline-flex; align-items:center; }

/* ページ送り */
.jdgm-paginate{ display:flex; justify-content:center; align-items:center; gap:6px; margin-top:26px; }
.jdgm-paginate__page{ min-width:34px; height:34px; display:inline-flex; align-items:center; justify-content:center;
  border-radius:6px; color:#ff5c01; font-size:1.5rem; cursor:pointer; text-decoration:none; }
.jdgm-paginate__page:hover{ background:#fff2e8; }
.jdgm-paginate__page.jdgm-curt{ background:#ff5c01; color:#fff; font-weight:700; cursor:default; }
.jdgm-rev-widg .jdgm-rev[hidden]{ display:none !important; }

/* 並べ方：横3枚 → 2枚 → 1枚。
   格子だと行の高さが一番高いカードに揃うので、写真のあるカードの横に大きな空白ができた。
   段組み（column）にして、カードを上から詰める。 */
.jdgm-rev-widg__reviews{ display:block !important; height:auto !important; position:static !important;
  column-count:1; column-gap:20px; }
@media (min-width:750px){ .jdgm-rev-widg__reviews{ column-count:2; } }
@media (min-width:1100px){ .jdgm-rev-widg__reviews{ column-count:3; } }

/* カード */
.jdgm-rev-widg .jdgm-rev{ position:static !important; left:auto !important; top:auto !important;
  display:inline-block; width:100% !important; margin:0 0 20px !important; padding:20px !important;
  break-inside:avoid; -webkit-column-break-inside:avoid; page-break-inside:avoid;
  border:1px solid #dcdce6 !important; border-radius:12px; background:#fff; }
.jdgm-rev-widg .jdgm-rev__header{ display:flex; flex-direction:column; gap:12px; }
.jdgm-rev-widg .jdgm-row-profile{ display:flex; align-items:center; gap:12px; order:1; }
.jdgm-rev-widg .jdgm-row-rating{ order:2; display:flex; align-items:center; }
/* judge.me 側が display:none で消していたので、名指しで出す */
.jdgm-rev-widg .jdgm-rev__icon{ display:flex !important; flex:0 0 auto; width:44px; height:44px; border-radius:50%;
  align-items:center; justify-content:center; font-size:18px !important; font-weight:700;
  width:44px !important; height:44px !important; min-width:44px; line-height:1 !important; overflow:hidden; }
.jdgm-rev-widg .jdgm-rev__icon::before,
.jdgm-rev-widg .jdgm-rev__icon::after{ content:none !important; display:none !important; }
.hone-rev__who{ display:flex; flex-direction:column; line-height:1.35; min-width:0; }
.jdgm-rev-widg .jdgm-rev__author-wrapper{ display:block; }
.jdgm-rev-widg .jdgm-rev__author{ font-weight:700 !important; color:#191919; font-size:1.6rem; }
.jdgm-rev-widg .jdgm-rev__timestamp{ display:block !important; color:#6b6b78; font-size:1.3rem; }
.jdgm-rev-widg .jdgm-rev__pics{ margin:14px 0 0; }
.jdgm-rev-widg .jdgm-rev__pic-link{ display:block; }
.jdgm-rev-widg .jdgm-rev__pic-img{ width:100%; height:auto; aspect-ratio:1/1; object-fit:cover; border-radius:8px; display:block; }
.jdgm-rev-widg .jdgm-rev__content{ margin-top:14px; }
.jdgm-rev-widg .jdgm-rev__body{ color:#191919; font-size:1.5rem; line-height:1.7; }
.jdgm-rev-widg .jdgm-rev__actions{ margin-top:14px; padding-top:12px; border-top:1px solid #ececf1; }
.jdgm-rev-widg .jdgm-rev__votes{ display:flex; gap:18px; }
.hone-rev__act{ background:none; border:0; padding:0; cursor:pointer; color:#6b6b78; font-size:1.3rem; }
.hone-rev__act:hover{ color:#191919; text-decoration:underline; }
.hone-rev__act.is-on{ color:#00b67a; font-weight:700; }
`;
  document.head.appendChild(st);
})();

/* ── カート（Shopify に載せた時だけ動く） ──────────────────────────
   完コピの時にテーマのカート用JSを剥がしているので、引き出しは開くだけで中身が無かった。
   ここで /cart/add.js・/cart.js・/cart/change.js を直に叩いて、
   元サイト（stepprs）と同じ形の引き出しを日本語で組み立てる。
   ローカルの file:// では Shopify のAPIが無いので、何もしないで黙って抜ける。 */
(() => {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const 表 = (() => { try { return JSON.parse(q('#ar-variants')?.textContent || 'null'); } catch { return null; } })();
  if (!表) return;                                   // 商品の対応表が無いページでは動かさない

  const 円 = (銭) => '¥' + Math.round(銭 / 100).toLocaleString('ja-JP');
  const 逃 = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* 選んでいる色とサイズから、売る単位（variant）を決める */
  const 選択 = () => {
    const 色 = q('input[name="COLOR"]:checked')?.getAttribute('aria-label')?.replace(/^カラー、/, '')
            || q('input[name="COLOR"]:checked')?.closest('.color-swatch')?.querySelector('.color-swatch__label')?.textContent.trim();
    const サイズ = (() => {
      const r = q('input[name="サイズ"]:checked') || q('input[name="Size"]:checked');
      if (!r) return null;
      return document.querySelector(`label[for="${r.id}"]`)?.textContent.trim().replace(/\s.*$/, '');
    })();
    // 束（1足/2足/3足/5足）も「売る単位」の一部。
    // 数だけ増やすと Shopify が1足の値段×個数で計算して、ページの束の値段にならない
    // 本数は radio の value（1/2/3/5）を正にする。
    // 前は札の文字から /(\d+)足/ で拾っていたので、5足の札の頭に付いている
    // 「1足あたり最安」の“1足”を先に読み、5足を選んでも1足が入っていた（2026-09-01 実測）
    const 本数 = (() => {
      const r = q('input[name="quantity"]:checked');
      if (!r) return '1足';
      const l = document.querySelector(`label[for="${r.id}"]`);
      const n = (String(r.value).match(/\d+/) || l?.getAttribute('data-quantity')?.match(/\d+/) || [])[0];
      return n ? n + '足' : '1足';
    })();
    const 組 = 表.variants || [];
    // 合う物が無い時に色とサイズだけで拾い直すと、選んでいない束（1足）が入る。
    // サイズを選んでいない時に 組[0] を返すと、黒を選んでいてもオレンジの22.5cmが入る。
    // どちらも起きていたので、合わない時は null を返して「入れない」（2026-09-01 実測）
    return 組.find((v) => (!v.カラー || v.カラー === 色) && (!v.サイズ || v.サイズ === サイズ) && (!v.本数 || v.本数 === 本数)) || null;
  };
  const 個数 = () => 1;   // 何足かは variant の側で持っている
  // 隠しの id を、選んだ組み合わせに合わせて書き換える
  // 束だけ決まっていて（既定は2足）サイズが未選択の時も、隠しの id はその束の物にしておく。
  // Meta の ViewContent がこの id と画面の値段を読むので、揃えないと計測がずれる
  const 束の代表 = () => {
    const r = q('input[name="quantity"]:checked');
    const l = r && document.querySelector(`label[for="${r.id}"]`);
    const n = r ? (String(r.value).match(/\d+/) || l?.getAttribute('data-quantity')?.match(/\d+/) || [])[0] : null;
    return (表.variants || []).find((x) => x.本数 === (n ? n + '足' : '1足')) || null;
  };
  const id同期 = () => { const v = 選択() || 束の代表(); if (v) qa('input[name="id"]').forEach((e) => { e.value = v.id; }); };

  /* 上の値段（と画面下の帯の値段）を、その束で実際に払う額にする。
     前は「1足あたりの値段」を出していたので、3足を選ぶと上は ¥3,080、カートは ¥9,240 で
     数字が合わなかった。1足あたりは束の札に「¥3,080 ／足」と出ているので消えない。
     数字はカートに送る variant と同じ #ar-variants から引く。Meta の ViewContent も
     画面の値段を読んでいるので、ここを直すと計測の値も揃う（2026-09-01） */
  const 円表記 = (n) => '¥' + Number(n).toLocaleString('ja-JP');
  const 価格同期 = () => {
    // 値段は本数だけで決まる（色・サイズでは変わらない）。
    // サイズを選ぶ前でも束の値段を出せるように、選択() ではなく本数で引く
    const v = 束の代表() || 選択();
    if (!v || !v.値) return;
    const 売 = 円表記(v.値), 定 = 円表記(v.定価 || v.値);
    qa('.main-price').forEach((e) => { e.textContent = 売; });
    qa('.main-comapre-price').forEach((e) => { e.textContent = 定; });
    qa('.sticky-atc__price .price__container .price-item').forEach((e) => {
      if (e.firstElementChild) return;                 // 中に別の要素がある枠（単価）は触らない
      e.textContent = e.closest('.price__compare-price') ? 定 : 売;
    });
  };
  const 同期 = () => { id同期(); 価格同期(); };
  qa('input[name="COLOR"], input[name="サイズ"], input[name="Size"], input[name="quantity"]').forEach((r) => r.addEventListener('change', 同期));
  qa('label[for^="quantity"], .color-swatch, .custom-pills label').forEach((l) => l.addEventListener('click', () => setTimeout(同期, 60)));
  同期();

  /* 引き出しの開け閉め */
  const 親 = q('.drawer'), 箱 = q('cart-drawer');
  const 開閉 = (開く) => {
    [親, 箱].forEach((el) => { if (!el) return;
      el.classList.toggle('active', 開く); el.classList.toggle('is-open', 開く);
      el.style.visibility = 開く ? 'visible' : ''; el.style.opacity = 開く ? '1' : '';
      el.style.transform = 開く ? 'translateX(0)' : ''; el.style.pointerEvents = 開く ? 'auto' : ''; });
    document.body.classList.toggle('overflow-hidden', 開く);
    // 上の「×」を足したブロックが出しっぱなしにする丸い×も一緒に消す
    const 丸 = q('button[aria-label="カートを閉じる"]'); if (丸) 丸.style.display = 開く ? '' : 'none';
  };

  /* ×・背景・Esc で閉じる。
     元の×は onclick="this.closest('cart-drawer').close()" だが、
     cart-drawer は customElements に登録していないので close() が無く、
     押すと例外が出るだけで閉じなかった（2026-09-01 実測）。
     inline を外して、開ける時と同じ 開閉() で閉じる。 */
  qa('.drawer__close, #CartDrawer-Overlay, .cart-drawer__overlay, [id*="CartDrawer-Overlay"]').forEach((b) => {
    b.removeAttribute('onclick');
    b.onclick = null;
    b.addEventListener('click', (e) => { e.preventDefault(); 開閉(false); });
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') 開閉(false); });

  /* 引き出しの中身を描く */
  const 描く = (cart) => {
    const 空 = cart.item_count === 0;
    箱?.classList.toggle('is-empty', 空);
    q('cart-drawer-items')?.classList.toggle('is-empty', 空);
    const 見出し = q('.drawer__heading'); if (見出し) 見出し.textContent = `カート・${cart.item_count}点`;
    qa('.cart-count-bubble span, #cart-icon-bubble .cart-count-bubble').forEach((e) => { if (e.children.length === 0) e.textContent = cart.item_count; });
    const 金 = q('.cart-drawer__totals__row__money'); if (金) 金.textContent = 円(cart.total_price);
    const 得 = q('.cart-drawer__total-savings');
    // /cart.js は定価（compare_at_price）を返さないので、対応表から引いて足す
    const 定価合計 = cart.items.reduce((a, i) => {
      const 定 = Number(表.定価?.[String(i.variant_id)] || 0) * 100;
      return a + (定 ? 定 * i.quantity : (i.original_line_price || i.line_price));
    }, 0);
    if (得) 得.textContent = 定価合計 > cart.total_price ? `${円(定価合計 - cart.total_price)} お得になっています` : '';
    const 進 = q('.cart-progress__bar__progress'); if (進) 進.style.width = '100%';
    const 文 = q('.cart-progress__text'); if (文) 文.innerHTML = '<span>全品送料無料です</span>';
    const 送 = q('#CartDrawer-Checkout'); if (送) 送.disabled = 空;

    const 入れ物 = q('#CartDrawer-CartItems');
    if (!入れ物) return;
    入れ物.innerHTML = 空 ? '' : `<ul class="ar-cart__list">${cart.items.map((i, n) => `
      <li class="ar-cart__item" data-line="${n + 1}">
        <a class="ar-cart__thumb" href="${逃(i.url)}">${i.image ? `<img src="${逃(i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'))}" alt="" width="80" height="80">` : ''}</a>
        <div class="ar-cart__body">
          <a class="ar-cart__name" href="${逃(i.url)}">${逃(i.product_title)}</a>
          ${i.variant_title && i.variant_title !== 'Default Title' ? `<p class="ar-cart__opt">${逃(i.variant_title.split(' / ').join('／'))}</p>` : ''}
          <div class="ar-cart__row">
            <div class="ar-cart__qty">
              <button type="button" data-step="-1" aria-label="1つ減らす">−</button>
              <span>${i.quantity}</span>
              <button type="button" data-step="1" aria-label="1つ増やす">＋</button>
            </div>
            <div class="ar-cart__price">
              ${i.original_line_price > i.line_price ? `<s>${円(i.original_line_price)}</s>` : ''}
              <strong>${円(i.line_price)}</strong>
            </div>
          </div>
          <button type="button" class="ar-cart__remove" data-remove>削除</button>
        </div>
      </li>`).join('')}</ul>`;
  };

  /* Shopify とのやりとり */
  const 読む = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const 直す = (line, quantity) => fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) }).then((r) => r.json());
  const 足す = (id, quantity) => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity }] }) })
    .then(async (r) => { if (!r.ok) throw new Error((await r.json()).description || 'カートに入りませんでした'); return r.json(); });

  const 更新 = async () => 描く(await 読む());

  /* 「カートに入れる」 */
  const 押した = async (e, id, 数) => {
    e.preventDefault();
    if (window.__arAdding) return;          // 二重タップで2点入るのを止める
    window.__arAdding = true;
    const b = e.currentTarget;
    const 元 = b.textContent; b.disabled = true;
    try {
      await 足す(id, 数);
      await 更新(); 開閉(true);
    } catch (err) {
      const 枠 = q('#CartDrawer-CartErrors') || q('.product-form__error-message-wrapper');
      if (枠) { 枠.textContent = err.message; 枠.style.display = 'block'; }
      else alert(err.message);
    } finally { window.__arAdding = false; b.disabled = false; b.textContent = 元; }
  };
  qa('button[name="add"], .product-form__submit, [data-atc]').forEach((b) => {
    if (b.closest('cart-drawer-upsell')) return;
    b.addEventListener('click', (e) => {
      const v = 選択();
      if (v) return 押した(e, v.id, 個数());
      // サイズ未選択のまま押すと、前は オレンジ/22.5cm/1足 が黙って入っていた。
      // 入れずに、選ぶ場所へ連れて行く（2026-09-01 実測）
      e.preventDefault();
      const 行 = q('variant-selects') || q('.product-form__input') || q('product-info');
      if (行) { 行.scrollIntoView({ behavior: 'smooth', block: 'center' }); 行.classList.add('hone-blink'); setTimeout(() => 行.classList.remove('hone-blink'), 1200); }
    });
  });
  // 引き出しの中の追加販売（マッサージローラー）
  qa('cart-drawer-upsell').forEach((u) => {
    const id = 表.roller || u.dataset.id;
    q('button', u)?.addEventListener('click', (e) => 押した(e, id, 1));
  });
  // 数を変える・消す
  document.addEventListener('click', async (e) => {
    const 枠 = e.target.closest('.ar-cart__item'); if (!枠) return;
    const line = Number(枠.dataset.line);
    if (e.target.closest('[data-remove]')) { await 直す(line, 0); return 更新(); }
    const s = e.target.closest('[data-step]');
    if (s) { const 今 = Number(q('.ar-cart__qty span', 枠).textContent); await 直す(line, Math.max(0, 今 + Number(s.dataset.step))); return 更新(); }
  });
  q('#CartDrawer-Checkout')?.addEventListener('click', (e) => { e.preventDefault(); location.href = '/checkout'; });

  const st = document.createElement('style');
  st.textContent = `
/* 中身が入ったら「カートは空です」の塊を隠す。
   元テーマは自前のJSでここを出し入れしていて、剥がしたら出しっぱなしになり、
   引き出しの上半分（819px）を空の案内が占めて、明細と合計が画面の下に押し出されていた */
cart-drawer:not(.is-empty) .drawer__inner-empty{ display:none !important; }
cart-drawer.is-empty .cart-drawer__body,
cart-drawer.is-empty .drawer__footer{ display:none !important; }
cart-drawer .drawer__inner{ display:flex !important; flex-direction:column; height:100%; }
cart-drawer .drawer__header{ flex:0 0 auto; }
cart-drawer .cart-drawer__body{ flex:1 1 auto; min-height:0; overflow-y:auto; display:block !important; }
cart-drawer .drawer__footer{ flex:0 0 auto; }
cart-drawer-items{ display:block; }
.ar-cart__list{ list-style:none; margin:0; padding:0; }
.ar-cart__item{ display:flex; gap:12px; padding:14px 0; border-bottom:1px solid #ececec; }
.ar-cart__thumb{ flex:0 0 80px; }
.ar-cart__thumb img{ width:80px; height:80px; object-fit:cover; border-radius:10px; display:block; background:#f4f4f4; }
.ar-cart__body{ flex:1 1 auto; min-width:0; }
.ar-cart__name{ display:block; font-weight:700; font-size:1.4rem; color:inherit; text-decoration:none; line-height:1.5; }
.ar-cart__opt{ margin:2px 0 8px; font-size:1.2rem; color:#6b6b6b; }
.ar-cart__row{ display:flex; align-items:center; justify-content:space-between; gap:10px; }
.ar-cart__qty{ display:inline-flex; align-items:center; border:1px solid #ddd; border-radius:8px; overflow:hidden; }
.ar-cart__qty button{ width:30px; height:30px; border:0; background:#fff; font-size:15px; cursor:pointer; color:#111; }
.ar-cart__qty button:hover{ background:#f5f5f5; }
.ar-cart__qty span{ min-width:28px; text-align:center; font-size:1.3rem; }
.ar-cart__price{ font-size:1.4rem; white-space:nowrap; }
.ar-cart__price s{ color:#9a9a9a; margin-right:6px; font-size:1.2rem; }
.ar-cart__remove{ margin-top:6px; background:none; border:0; padding:0; font-size:1.2rem; color:#8a8a8a; text-decoration:underline; cursor:pointer; }
.ar-cart__remove:hover{ color:#111; }`;
  document.head.appendChild(st);

  更新();
})();

/* ── 色を選んだら、上の大きい写真もその色に変える ───────────────
   最初これをカートの塊の中に書いてしまい、#ar-variants が無いローカルでは
   その塊ごと return していて一度も動かなかった。独立させる。 */
(() => {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const サムネ = qa('.thumbnail-list__item');
  const 色玉 = qa('input[name="COLOR"]');
  if (!サムネ.length || !色玉.length) return;
  const 押す = (色) => {
    const 鍵 = String(色 || '').toLowerCase();
    if (!鍵) return;
    const t = サムネ.find((x) => new RegExp(`-${鍵}-insoles`, 'i').test(q('img', x)?.getAttribute('src') || ''));
    if (!t) return;
    (q('button', t) || t).click();
  };
  色玉.forEach((r) => r.addEventListener('change', () => 押す(r.value)));
  押す(q('input[name="COLOR"]:checked')?.value);
})();
